import { Tabs, Button } from 'antd';
import { isEmpty } from 'lodash/fp';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { updateAudiCalculation } from '../../../../shared/permissions';
import { type AudiCalculationModuleSpecsFragment } from '../../../api/fragments';
import ConsolePageWithHeader from '../../../layouts/ConsoleLayout/ConsolePageWithHeader';
import AudiCalculationManagement from './AudiCalculationManagement';

type AudiCalculationDetailsInnerPageProps = {
    modules: (AudiCalculationModuleSpecsFragment & { permissions: string[] })[];
};

const AudiCalculationDetailsInnerPage = ({ modules }: AudiCalculationDetailsInnerPageProps) => {
    const { t } = useTranslation(['audiCalculationDetails']);
    const tabs = useMemo(() => modules.map(module => ({ key: module.id, tab: module.displayName })), [modules]);
    const [activeTab, setActiveTab] = useState(tabs?.[0]?.key);
    const module = useMemo(() => (activeTab ? modules.find(({ id }) => id === activeTab) : null), [activeTab, modules]);

    const render = () => {
        if (isEmpty(module)) {
            return null;
        }

        return <AudiCalculationManagement key={activeTab} module={module} />;
    };

    return (
        <ConsolePageWithHeader
            footer={[
                module.permissions?.find(permission => permission === updateAudiCalculation) && (
                    <Button key="submit" form={`audiCalculationDetails-${activeTab}`} htmlType="submit" type="primary">
                        {t('audiCalculationDetails:actions.update')}
                    </Button>
                ),
            ]}
            header={{
                footer:
                    tabs.length > 1 ? (
                        <Tabs onChange={activeKey => setActiveTab(activeKey)}>
                            {tabs.map(tab => (
                                <Tabs.TabPane key={tab.key} tab={tab.tab} />
                            ))}
                        </Tabs>
                    ) : null,
            }}
            title={t('audiCalculationDetails:title')}
        >
            {render()}
        </ConsolePageWithHeader>
    );
};

export default AudiCalculationDetailsInnerPage;
